import styled from '@emotion/styled';

import variables from 'theme/styles/vars';

export default styled.div`
    position: relative;
    width: 100%;
    padding: 5em 0;
    background-color: #10F5B0;
    display: flex;
    justify-content: center;
    align-items: center;

    .layout-container {
        display: flex;
        justify-content: space-between;
        align-items: center;
    }

    .public-layout-description {
        width: 50%;

        .saved {
            display: flex;
            justify-content: flex-start;
            align-items: center;
            gap: 1em;
        }

        .saved-txt {
            font-size: 1.25em;
            font-weight: 700;
        }
    }

    @media all and (max-width: ${variables.mobileM}) {
        background-position: center;

        .animation {
            display: none;
        }

        .public-layout-description {
            width: 100%;

            .copy {
                .headline {
                    font-size: 1.7em;
                    font-weight: 700;
                }

                .subheadline {
                    font-size: 2.2em;
                }
                .description {
                    margin:1em 0 0em 0;
                }
            }

            .description-button {
                display: flex !important;
                margin-top: 2em;

                a,
                .button {
                    width: 100%;
                }
            }
        }
    }

`;